export default __webpack_public_path__ + "static/media/ic_internet.bfad0237.svg";